export default __webpack_public_path__ + "0e6b2c3f958f7911604a5b6356bdba68.svg";